var chunkMapping = {
	"353": [
		92353
	],
	"657": [
		36657
	],
	"672": [
		94672
	]
};
var idToExternalAndNameMapping = {
	"36657": [
		"default",
		"./JobDetailModal",
		77995
	],
	"92353": [
		"default",
		"./ClaimDetailModal",
		33407
	],
	"94672": [
		"default",
		"./module",
		75174
	]
};
var idToRemoteMap = {
	"36657": [
		{
			"externalType": "script",
			"name": "jobManagement"
		}
	],
	"92353": [
		{
			"externalType": "script",
			"name": "claimManagement"
		}
	],
	"94672": [
		{
			"externalType": "script",
			"name": "servicejob_management"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"36657": {
		"shareScope": "default",
		"name": "./JobDetailModal",
		"externalModuleId": 77995,
		"remoteName": "jobManagement"
	},
	"92353": {
		"shareScope": "default",
		"name": "./ClaimDetailModal",
		"externalModuleId": 33407,
		"remoteName": "claimManagement"
	},
	"94672": {
		"shareScope": "default",
		"name": "./module",
		"externalModuleId": 75174,
		"remoteName": "servicejob_management"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}